import React, { useEffect } from "react";
import BackLink from "../components/BackLink";
import { Alert, Button, Col, Row } from "react-bootstrap";
import { useGetQuestionnaireQuery } from "../features/rapidstor/rapidstorApiSlice";
import { useLoaderData, useNavigate } from "react-router-dom";
import Location from "../features/rapidstor/entities/Location";
import JourneyProgress from "../components/JourneyProgress";
import Questionnaire from "../components/Questionnaire/Questionnaire";
import store from "../store";
import { setLocation, setResponse } from "../store/questionnaireSlice";
import { useSelector } from "react-redux";
import { selectStartTime, setStartTime } from "../store/bookingSlice";
import { DateTime } from "luxon";
import Countdown from "../components/Countdown";

function QuestionnairePage() {
  const location = useLoaderData() as Location;
  const navigate = useNavigate();
  const startTime = useSelector(selectStartTime);

  useEffect(() => {
    if (startTime === null) {
      store.dispatch(setStartTime(DateTime.now().toUnixInteger()));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data, isLoading, error, refetch } = useGetQuestionnaireQuery(
    location?.locationCode ?? ""
  );

  const skipToUnitListing = (event: React.MouseEvent) => {
    event.preventDefault();
    store.dispatch(setLocation(location));
    store.dispatch(setResponse({ id: "storageType", response: "All Units" }));
    navigate(`/locations/${location.slug}/units`);
  };

  // const skipToRapidstor = (event: React.MouseEvent) => {
  //   event.preventDefault();
  //   store.dispatch(setLocation(location));
  //   store.dispatch(setResponse({ id: "storageType", response: "All Units" }));
  //   navigate("/booking");
  // };

  let questionnaireElement;
  if (!location) {
    questionnaireElement = "Loading location...";
  } else if (isLoading) {
    questionnaireElement = "Loading questions...";
  } else if (!data || error) {
    questionnaireElement = (
      <Alert className={"mt-4"} variant={"secondary"}>
        Sorry, we were unable to load the questionnaire.{" "}
        <div className={"mt-2"}>
          <Button onClick={skipToUnitListing} className={"me-2"}>
            Show all storage options
          </Button>{" "}
          or{" "}
          <Button onClick={refetch} className={"ms-2"} variant={"secondary"}>
            Retry
          </Button>
        </div>
      </Alert>
    );
  } else {
    questionnaireElement = <Questionnaire questionnaire={data} />;
  }

  return (
    <>
      {/* {!options.enabledLocations.includes("L005") && <BackLink desktop />} */}
      <BackLink desktop />
      <Row>
        <Col xs={12}>
          <JourneyProgress mobile className={"mt-2"} />
          <Countdown minutes={20} seconds={0} />
          {questionnaireElement}
        </Col>
      </Row>
    </>
  );
}

export default QuestionnairePage;
